module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "id": "lockAllModelsButton"
    },
    on: {
      "click": function($event) {
        return _vm.lockAllModels()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Lock all models\n                        ")])]), _vm._v(" "), _c('p'), _c('header', [_vm._v("Lock all models for editing")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "id": "unlockAllModelsButton"
    },
    on: {
      "click": function($event) {
        return _vm.unlockAllModels()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-unlock"
  }), _vm._v(" Unlock all\n                        ")])]), _vm._v(" "), _c('p'), _c('header', [_vm._v("Removes all model edit locks")]), _vm._v(" "), _c('p')])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Model Locks")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2e3fd824", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e3fd824"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/model-locks/model-locks-admin.vue.html
// module id = 1090
// module chunks = 0